import "./Whole.css"

import { useCallback, useEffect, useState } from "react"
import { Navigate, Routes, Route } from "react-router-dom"

import ForgotPassword from "../Account/ForgotPassword/ForgotPassword"
import CreateAccount from "../Account/CreateAccount/CreateAccount"
import ChangePassword from "../Account/ChangePassword/ChangePassword"

import Login from "../Account/Login/Login"

import UploadedForm from "../Data/Visualize/UploadedForms/UploadedForm"
import UploadHistorySubpage from "../Data/Visualize/UploadsSubpages/UploadHistorySubpage"
import PatientFiles from "../Data/Visualize/Subpages/PatientFiles"

import DataVisualize from "../Data/Visualize/DataVisualize"
import VisualizePatient from "../Data/Visualize/Subpages/VisualizePatient"
import { Visualization } from "../../Managers/VisualizationManager/Visualization"

import UserManagement from "../Admin/Users/UserManagement"
import RolesAndPermissions from "../Admin/Users/RolesAndPermissions"
import Projects from "../Admin/Projects/Projects"
import Sites from "../Admin/Sites/Sites"

import ErrorPage from "../Error/ErrorPage"
import { RequireAuth } from "../Error/RequireAuth"

import loadingSvg from "./smartneuro.svg"
import InactivityPage from "../Error/InactivityPage"

import { authUpdates, useAuthProvider } from "../../Providers/AuthProvider"
import { FRONTEND_LINKS } from "../../Constants/FrontendLinks"
import { useUploadIntoQueueProvider } from "../../Providers/UploadIntoQueueProvider"
import UploadQueue from "../Data/Visualize/UploadsSubpages/UploadQueue"
import { useModalProvider } from "../../Providers/ModalProvider"
import UploadWindow from "../Data/Visualize/UploadsSubpages/UploadWindow"
import { UploadProcessProvider } from "../../Providers/UploadProcessProvider"
import Toast from "../../Components/Toast/Toast"
import CuringComaLogin from "../Account/CuringComaLogin/CuringComaLogin"
import { useOnMount } from "../../Hooks/useOnMount"
import { MainLayout } from "./MainLayout"

import { useWorkspacesProvider } from "../../Providers/WorkspacesProvider"

function Whole() {
    const uploadIntoQueueProvider = useUploadIntoQueueProvider();
    const [sidebar, setSidebarState] = useState(true)
    const [navPage, setNavPageState] = useState(true)
    const { createModal } = useModalProvider()
    const { selectedWorkspace } = useWorkspacesProvider()

    const setSidebar = useCallback(
        newSidebarState => {
            if (newSidebarState !== sidebar) {
                setSidebarState(newSidebarState)
            }
        },
        [sidebar]
    )

    const setNavPage = useCallback(
        newNavPageState => {
            if (newNavPageState !== navPage) {
                setNavPageState(newNavPageState)
            }
        },
        [navPage]
    )

    function renderUploadModal() {
        createModal(
            <UploadProcessProvider>
                <UploadWindow escClose={false} clickOutsideClose={false} />
            </UploadProcessProvider>
        )
    }

    useEffect(() => {
        if (uploadIntoQueueProvider.openLoading === true) {
            renderUploadModal()
        }
    }, [uploadIntoQueueProvider.openLoading])

    const authProvider = useAuthProvider()

    useOnMount(() => {
        authProvider.update(authUpdates.TOKEN, authUpdates.PERMISSIONS)
    })

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            sessionStorage.removeItem('currentUploads')
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [])

    return authProvider.userIsLoggedIn &&
        (authProvider.permissions === undefined || Object.keys(authProvider.permissions).length === 0) ?
        (
            <div style={{
                color: 'black',
                display: "block",
                textAlign: "center",
                marginTop: `${window.innerHeight / 4}px`
            }}>
                <img src={loadingSvg} alt="loading" style={{ width: "300px" }} />
                <h2 style={{
                    fontFamily: "Montserrat",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "25px",
                    marginTop: "10px"
                }}>
                    Loading Workspace...
                </h2>
            </div>
        ) : (
            <>
                            <Routes>
                                <Route element={<MainLayout navPage={navPage} setNavPage={setNavPage} sidebar={sidebar} setSidebar={setSidebar} />}>
                                {<Route
                                    exact
                                    path="/"
                                    element={
                                        <div>
                                            {selectedWorkspace === "CURINGCOMA" ?
                                                <CuringComaLogin
                                                    setNavPage={setNavPage}
                                                />
                                                :
                                                <Login
                                                    setNavPage={setNavPage}
                                                />
                                            }
                                        </div>
                                    }
                                />
                                }
                                {true &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.FORGOT_PASSWORD.MAIN}
                                        element={
                                            <ForgotPassword
                                                setSidebar={setSidebar}
                                                setNavPage={setNavPage}
                                            />
                                        }
                                    />
                                }

                                {true &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.INACTIVE.MAIN}
                                        element={
                                            <InactivityPage setNavPage={setNavPage} />
                                        }
                                    />
                                }

                                {true &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.CREATE_ACCOUNT.MAIN}
                                        element={
                                            <CreateAccount
                                                setNavPage={setNavPage}
                                            />
                                        }
                                    />
                                }

                                {true &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.CHANGE_PASSWORD.MAIN}
                                        element={
                                            <ChangePassword
                                                setNavPage={setNavPage}
                                            />
                                        }
                                    />
                                }

                                {true && <Route path={FRONTEND_LINKS.SUBPAGES.DATA.MAIN} element={<Navigate to={FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.SUMMARY.MAIN} />} />}

                                {
                                    authProvider.permissions?.access_data_upload_patient_subpage &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.FORMS.SUBPAGES.PATIENT.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_data_upload_patient_subpage']}
                                                setNavPage={setNavPage}>
                                                <UploadedForm
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    >
                                    </Route>
                                }
                                {authProvider.permissions?.access_data_upload_patient_subpage &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.UPLOAD.SUBPAGES.PATIENT.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_data_upload_patient_subpage']}
                                                setNavPage={setNavPage}
                                            >
                                                <UploadHistorySubpage
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                    canUpload={true}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }
                                {authProvider.permissions?.access_data_upload_patient_subpage &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.FILES.SUBPAGES.PATIENT.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_data_upload_patient_subpage']}
                                                setNavPage={setNavPage}
                                            >
                                                <PatientFiles
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }
                                {authProvider.permissions?.access_data_upload_patient_subpage &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.SUBPAGES.PATIENTS.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_data_upload_patient_subpage']}
                                                setNavPage={setNavPage}
                                            >
                                                <VisualizePatient
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }

                                {authProvider.permissions?.access_data_visualize &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_data_visualize']}
                                                setNavPage={setNavPage}
                                            >
                                                <DataVisualize
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                    setNavPage={setNavPage}
                                                    navPage={navPage}
                                                    canUpload={true}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }

                                {authProvider.permissions?.access_admin_user_management &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.ADMIN.MAIN}
                                        element={
                                            <Navigate
                                                to={FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.MAIN}
                                            />
                                        }
                                    />
                                }

                                {authProvider.permissions?.access_admin_user_management &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_admin_user_management']}
                                                setNavPage={setNavPage}
                                            >
                                                <UserManagement
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }

                                {authProvider.permissions?.access_admin_role_and_permissions &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.USER_MANAGEMENT.SUBPAGES.ROLES_AND_PERMISSIONS.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_admin_role_and_permission']}
                                                setNavPage={setNavPage}
                                            >
                                                <RolesAndPermissions
                                                    sidebar={sidebar}
                                                    setSidebar={setSidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }

                                {authProvider.permissions?.access_admin_studies &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.STUDIES.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_admin_studies']}
                                                setNavPage={setNavPage}
                                            >
                                                <Projects
                                                    sidebar={sidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }

                                {authProvider.permissions?.access_admin_sites &&
                                    <Route
                                        path={FRONTEND_LINKS.SUBPAGES.ADMIN.SUBPAGES.SITES.MAIN}
                                        element={
                                            <RequireAuth
                                                permissions={['access_admin_sites']}
                                                setNavPage={setNavPage}
                                            >
                                                <Sites
                                                    sidebar={sidebar}
                                                />
                                            </RequireAuth>
                                        }
                                    />
                                }

                                {true &&
                                    <Route
                                        path="*"
                                        element={
                                            <div>
                                                <ErrorPage
                                                    setNavPage={setNavPage}
                                                />
                                            </div>
                                        }
                                    />
                                }
                                </Route>

                                {/* Routes that do not use the Header and Sidebar go here */}
                                {authProvider.permissions?.access_data_upload_patient_subpage &&
                                    <Route
                                        // TODO: there is unneeded information in the URL
                                        path={`${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.REVIEW.MAIN}/:patientID/:patientIdentifier/:siteName/:dataObjectID/:dataObjectName`}
                                        element={
                                            <RequireAuth
                                                permissions={['access_data_upload_patient_subpage']}
                                                setNavPage={setNavPage}
                                            >
                                                <Visualization />
                                            </RequireAuth>
                                        }
                                    />
                                }

                            </Routes>
                            {uploadIntoQueueProvider.openQueue && (
                                <div>
                                    <UploadQueue />
                                </div>
                            )}

                <Toast />
            </>
        )
}

export default Whole
